// extracted by mini-css-extract-plugin
export var button = "styles-module--button--31921";
export var container = "styles-module--container--0ded0";
export var name = "styles-module--name--d96a3";
export var plusIcon = "styles-module--plusIcon--6ffd3";
export var subcategory = "styles-module--subcategory--3c482";
export var text = "styles-module--text--785fb";
export var topText = "styles-module--topText--1aab4";